const INIT_FILTER_VALUE = {
  user_group: {
    "role_code": "cm",
    "position_name": "เจ้าหน้าที่พัฒนาสังคมและความมั่นคงของมนุษย์",
    "position_name_short": "เจ้าหน้าที่ พม."
  },
  organize: null,
  sub_organize: null,
  province: null,
  username: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
};

// mutations
const mutations = {
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
};
const getters = {
  getAllFilter: (state) => {
    return state;
  },
  getFilterSummaryArray: (state) => {
    let prepareState = { ...state };
    let result = [];
    if (prepareState.user_group)
      result.push({
        title: "กลุ่มผู้ใช้งาน",
        text: prepareState.user_group.role_code.toUpperCase(),
      });
    if (prepareState.organize)
      result.push({
        title: "หน่วยงาน",
        text: prepareState.organize.AGC_NAME,
      });
    if (prepareState.sub_organize)
      result.push({
        title: "หน่วยงานย่อย",
        text: prepareState.sub_organize.ORG_NAME,
      });
    if (prepareState.province)
      result.push({
        title: "จังหวัด",
        text: prepareState.province.province_name,
      });
    if (prepareState.username)
      result.push({
        title: "ผู้ใช้งาน",
        text: prepareState.username,
      });
    return result;
  },
  getFilterForApi: (state) => {
    const result = {};
    if (state.user_group) result.user_group = state.user_group.role_code;
    if (state.organize) result.organize = state.organize.AGC_CODE.toString();
    if (state.sub_organize) result.sub_organize = state.sub_organize.ORG_CODE.toString();
    if (state.province) result.province = state.province._id.province_ID.toString();
    if (state.username) result.username = state.username;
    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
